// @ts-nocheck

import React, { useMemo } from 'react';

import { externalLinkOpen } from '../../actions/externallink';
import { getRedirectUrl, RedirectServices } from '../../config/urls';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import UserInfo from './UserInfo';

type UserInfoPropsType = {
  className?: string;
  onUserClick: () => void;
};

const UserInfoContainer = (ownProps: UserInfoPropsType) => {
  const actions = useMemo(
    () => ({
      openExternalLink: externalLinkOpen,
    }),
    [],
  );

  const bindedActions = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({
    ownProps,
    actionsProps: {
      onDepositButtonClick: () =>
        bindedActions.openExternalLink(getRedirectUrl(RedirectServices.DEPOSIT), {
          auth: true,
          inNewTab: false,
        }),
    },
  });

  return <UserInfo {...enhancedProps} />;
};

export default UserInfoContainer;
